// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"0326469f","655":"17d79846"}[chunkId] + ".chunk.js";
};